// document.addEventListener("DOMContentLoaded", function () {
//     let isLoading = false;

//     var infiniteScroll = new Ajaxinate({
//         container: '.ProductList--grid',
//         pagination: '#CollectionPagination',
//         method: 'click',
//         loadingText: 'Loading...',
//         callback: function () {
//             isLoading = false;

//             var loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
//             if (loader) loader.style.display = "none";

//         document.querySelectorAll('.ProductItem').forEach(function (item) {
//         if (getComputedStyle(item).visibility === "hidden") {
//             item.style.visibility = "visible";
//         }
//     });
//         }
//     });

//     // Button click handler
//     document.addEventListener("click", function (e) {

//         const btn = e.target.closest("#load-more-btn");
//         if (!btn) return;

//         e.preventDefault();

//         if (isLoading) return;

//         const nextLink = document.querySelector("#CollectionPagination a.pagination__next");

//         if (!nextLink) {
//             console.log("No next page found");
//             return;
//         }

//         isLoading = true;

//         // loader show
//         const loader = document.querySelector('#CollectionPagination .loading-overlay__spinner');
//         if (loader) loader.style.display = "inline-block";

//         // IMPORTANT: trigger Ajaxinate properly
//         nextLink.click();
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
    let isLoading = false;

    var infiniteScroll = new Ajaxinate({
        container: '.ProductList--grid',
        pagination: '#CollectionPagination',
        method: 'click',
        loadingText: 'Loading...',
        callback: function () {
            isLoading = false;

            var pagination = document.querySelector("#CollectionPagination");
            var paginationn = document.querySelector("#load_collection");
            var loader = document.querySelector(
                '#CollectionPagination .loading-overlay__spinner'
            );

            if (loader) {
                loader.style.display = "none";
            }

            // Product visibility
            document.querySelectorAll('.ProductItem').forEach(function (item) {
                if (getComputedStyle(item).visibility === "hidden") {
                    item.style.visibility = "visible";
                }
            });

            // Check if this is the last page
            var nextLink = document.querySelector(
                "#CollectionPagination a.pagination__next"
            );

            if (!nextLink && paginationn) {
                paginationn.classList.add("last_page");
            } else if (paginationn) {
                paginationn.classList.remove("last_page");
            }
        }
    });

    // Button click handler
    document.addEventListener("click", function (e) {

        const btn = e.target.closest("#load-more-btn");
        if (!btn) return;

        e.preventDefault();

        if (isLoading) return;

        const nextLink = document.querySelector(
            "#CollectionPagination a.pagination__next"
        );

        if (!nextLink) {
            console.log("No next page found");

            // Last page
            document.querySelector("#load_collection")
                ?.classList.add("last_page");

            return;
        }

        isLoading = true;

        // Show loader
        const loader = document.querySelector(
            '#CollectionPagination .loading-overlay__spinner'
        );

        if (loader) {
            loader.style.display = "inline-block";
        }

        // Trigger Ajaxinate
        nextLink.click();
    });
});